import _ from "lodash";

import Api from "../helpers/Api";

import {
  serverError,
  showToast,
  UPDATE_HOME_REDUCER,
  UPDATE_FEE_REDUCER_DATA,
} from ".";

export const UPDATE_STUDENT_DATA = "Student/UPDATE_STUDENT_DATA";
export const RESET_STUDENT_DATA = "Student/RESET_STUDENT_DATA";

export const PAYMENT_TYPES_FEE = {
  CASH: 0,
  CHEQUE: 1,
  DD: 2,
  SCHOLARSHIP: 3,
  CONCESSION: 4,
  ONLINE_TRANSFER: 5,
  FEE_REDUCTION: 6,
  CARD: 7,
  CASH_DEPOSIT: 9,
};

export const PAYMENT_TYPES = {
  CASH: 0,
  CHEQUE: 1,
  DD: 2,
  SCHOLARSHIP: 3,
  CONCESSION: 4,
  ONLINE_TRANSFER: 5,
  FEE_REDUCTION: 6,
  CARD: 7,
  EXTERNAL_PAYMENT: 8,
  CASH_DEPOSIT: 9,
};
export const PAYMENT_TYPE = {
  Cash: 0,
  Cheque: 1,
  DD: 2,
  Scholarship: 3,
  Concession: 4,
  "Online Transfer": 5,
  "Fee Reduction": 6,
  Card: 7,
  "External Payment": 8,
  "Cash Deposit": 9,
};

export const REFUND_PAYMENT_TYPES = {
  CASH: 0,
  ONLINE_TRANSFER: 1,
};

export const resetStudent = () => async (dispatch) => {
  await dispatch({
    type: RESET_STUDENT_DATA,
  });
};

const showLoader = (show) => async (dispatch) => {
  await dispatch({
    type: UPDATE_STUDENT_DATA,
    payload: {
      isLoading: show,
    },
  });
};

export const getStudentList =
  (
    searchText,
    selectedCampus,
    selectedClassroom,
    selectedTagIds,
    sortBy,
    page,
    perPage,
    isExport = false
  ) =>
  async (dispatch) => {
    await dispatch(showLoader(true));
    const response = await Api({
      method: "get",
      url: `/fees/get_student_list?search_text=${searchText}&selected_campus=${JSON.stringify(
        selectedCampus
      )}&selected_classroom=${JSON.stringify(
        selectedClassroom
      )}&selected_tag_ids=${JSON.stringify(
        selectedTagIds
      )}&sort_by=${sortBy}&page=${page}&per_page=${perPage}&is_export=${isExport}`,
    });

    if (response.success) {
      if (isExport) {
        await dispatch({
          type: UPDATE_STUDENT_DATA,
          payload: {
            exportStudents: response.students,
          },
        });
      } else {
        await dispatch({
          type: UPDATE_STUDENT_DATA,
          payload: {
            students: response.students,
            filteredStudentsLength: response.total_students,
            totalFeeDue: response.total_fee_due,
            totalFeePaid: response.total_fee_paid,
          },
        });
        await dispatch({
          type: UPDATE_FEE_REDUCER_DATA,
          payload: {
            classrooms: response.classrooms,
            campuses: response.campuses,
            institutesTags: response.tags,
            institutesTagGroups: response.tag_groups,
          },
        });
        await dispatch({
          type: UPDATE_HOME_REDUCER,
          payload: {
            isAdmin: response.is_admin,
            isFinanceAdmin: response.is_finance_admin,
            isFinance: response.is_finance,
          },
        });
      }
    } else {
      await dispatch({
        type: UPDATE_HOME_REDUCER,
        payload: { isLocked: response.is_locked },
      });
    }
    await dispatch(showLoader(false));
    if (!!response.message) {
      await dispatch(showToast(response.message));
    }
    return response;
  };

export const createNewStudent =
  (
    studentName,
    badgeId,
    phone,
    studentEmail,
    classroomId,
    classroomName,
    studentCampus,
    courseId,
    active,
    fatherName,
    fatherPhone,
    dob,
    fatherEmail,
    motherName,
    motherPhone,
    motherEmail,
    address,
    bloodGroup,
    doj,
    studentElectives,
    institutesTagIds,
    isHostelite
  ) =>
  async (dispatch) => {
    const studentElectivesData = studentElectives
      ? JSON.stringify(studentElectives)
      : [];
    const response = await Api({
      method: "post",
      url: "/institutes/create_new_student",
      data: {
        first_name: studentName,
        phone,
        badge_id: badgeId,
        classroom_id: classroomId,
        classroom_name: classroomName,
        campus_name: studentCampus,
        course_id: courseId,
        email: studentEmail,
        active,
        parent_name: fatherName,
        parent_phone: fatherPhone,
        dob: dob,
        father_email: fatherEmail,
        mother_name: motherName,
        mother_phone: motherPhone,
        mother_email: motherEmail,
        address: address,
        bloodGroup: bloodGroup,
        doj: doj,
        studentElectives: studentElectivesData,
        tag_ids: JSON.stringify(institutesTagIds),
        is_hostelite: isHostelite,
      },
    });
    dispatch(showToast(response.message));
    await dispatch(getStudentList());
    return response;
  };

export const updateTransaction =
  (studentId, transactionId, paymentDate, editedPayments, reason) =>
  async (dispatch) => {
    const response = await Api({
      method: "post",
      url: "/fees/update_transaction",
      data: {
        student_id: studentId,
        transaction_id: transactionId,
        payment_date: paymentDate,
        edited_payments: JSON.stringify(editedPayments),
        reason: reason,
      },
    });
    if (response.success) {
      await dispatch(showToast("Payment updated"));
      await dispatch({
        type: UPDATE_STUDENT_DATA,
        payload: {
          feePaid: response.fee_paid,
          unallocatedAmount: response.unallocated_amount,
        },
      });
    }
    if (response.message) {
      await dispatch(showToast(response.message));
    }
    return response;
  };

export const updateRefundTransaction =
  (studentId, transactionId, refundDate, editedRefunds, reason) =>
  async (dispatch) => {
    const response = await Api({
      method: "post",
      url: "/fees/update_refund_transaction",
      data: {
        student_id: studentId,
        transaction_id: transactionId,
        refund_date: refundDate,
        edited_refunds: JSON.stringify(editedRefunds),
        reason: reason,
      },
    });
    if (response.success) {
      await dispatch(showToast("Refund updated"));
      await dispatch({
        type: UPDATE_STUDENT_DATA,
        payload: {
          feePaid: response.fee_paid,
          unallocatedAmount: response.unallocated_amount,
        },
      });
    }
    if (response.message) {
      await dispatch(showToast(response.message));
    }
    return response;
  };

export const getStudentFeeDetails = (studentID) => async (dispatch) => {
  await dispatch(showLoader(true));
  const response = await Api({
    method: "get",
    url: `/fees/get_student_fee_details?id=${studentID}`,
  });
  if (response.success) {
    await dispatch({
      type: UPDATE_STUDENT_DATA,
      payload: {
        ...response.studentData,
        campuses: response.campuses,
        courses: response.courses,
        classrooms: response.classrooms,
        feeDues: response.fee_dues,
        feePaid: _.sortBy(response.fee_paid, ["payment_id"], ["asc"]),
        institute: response.institute,
        feeNotes: response.fee_notes,
        refundDetails: response.refund_details,
        totalFee: response.total_fee,
        paymentsEditHistory: response.payments_edit_history,
        unallocatedAmount: response.unallocated_amount,
      },
    });
    await dispatch({
      type: UPDATE_HOME_REDUCER,
      payload: {
        feeAccounts: response.fee_accounts,
      },
    });
  }
  if (response.message) {
    await dispatch(showToast(response.message));
  }
  await dispatch(showLoader(false));
  return response;
};

export const changePaymentTypeForFeeDue =
  (feeDueID, paymentType) => async (dispatch, getState) => {
    const { feeDues } = getState().student;

    let unSortedFeeDues = [
      ...feeDues.filter((due) => Number(due.fee_due_id) !== Number(feeDueID)),
      {
        ...feeDues.find((due) => Number(due.fee_due_id) === Number(feeDueID)),
        payment_type: paymentType,
      },
    ];
    unSortedFeeDues = [
      ...unSortedFeeDues.sort((a, b) => {
        if (a.priority < b.priority) return 1;
        if (a.priority > b.priority) return -1;
        if (a.fee_due_id < b.fee_due_id) return 1;
        if (a.fee_due_id > b.fee_due_id) return -1;
      }),
    ];
    await dispatch({
      type: UPDATE_STUDENT_DATA,
      payload: {
        feeDues: unSortedFeeDues,
      },
    });
  };

export const changePaymentTypeForRefund =
  (feePaymentId, paymentType) => async (dispatch, getState) => {
    const { feePaid } = getState().student;
    let unSortedPayments = [
      ...feePaid.filter(
        (payment) => Number(payment.payment_id) !== Number(feePaymentId)
      ),
      {
        ...feePaid.find(
          (payment) => Number(payment.payment_id) === Number(feePaymentId)
        ),
        payment_type: paymentType,
      },
    ];
    unSortedPayments = _.sortBy([...unSortedPayments], ["payment_id"], ["asc"]);
    await dispatch({
      type: UPDATE_STUDENT_DATA,
      payload: {
        feePaid: [...unSortedPayments],
      },
    });
  };

export const changeMachineIdForFeeDue =
  (feeDueID, machineId) => async (dispatch, getState) => {
    const { feeDues } = getState().student;

    let unSortedFeeDues = [
      ...feeDues.filter((due) => Number(due.fee_due_id) !== Number(feeDueID)),
      {
        ...feeDues.find((due) => Number(due.fee_due_id) === Number(feeDueID)),
        machine_id: machineId,
      },
    ];
    unSortedFeeDues = [
      ...unSortedFeeDues.sort((a, b) => {
        if (a.priority < b.priority) return 1;
        if (a.priority > b.priority) return -1;
        if (a.fee_due_id < b.fee_due_id) return 1;
        if (a.fee_due_id > b.fee_due_id) return -1;
      }),
    ];
    await dispatch({
      type: UPDATE_STUDENT_DATA,
      payload: {
        feeDues: unSortedFeeDues,
      },
    });
  };

export const changePaymentAmountForDue =
  (feeDueID, paymentDate, amount) => async (dispatch, getState) => {
    const { feeDues } = getState().student;

    let unSortedFeeDues = [
      ...feeDues.filter((due) => Number(due.fee_due_id) !== Number(feeDueID)),
      {
        ...feeDues.find((due) => Number(due.fee_due_id) === Number(feeDueID)),
        payment: amount || 0,
        payment_date: paymentDate,
      },
    ];
    unSortedFeeDues = [
      ...unSortedFeeDues.sort((a, b) => {
        if (a.priority < b.priority) return 1;
        if (a.priority > b.priority) return -1;
        if (a.fee_due_id < b.fee_due_id) return 1;
        if (a.fee_due_id > b.fee_due_id) return -1;
      }),
    ];
    await dispatch({
      type: UPDATE_STUDENT_DATA,
      payload: {
        feeDues: unSortedFeeDues,
      },
    });
  };

export const performSplitUpForExternal =
  (amount, refundTotalDetails, feeDue) => async (dispatch) => {
    let feeDues = feeDue;
    let remainingAmount = amount;
    feeDues.forEach((fee, index) => {
      if (remainingAmount) {
        if (
          remainingAmount >
          (refundTotalDetails[fee.fee_due_id]
            ? fee.balance + refundTotalDetails[fee.fee_due_id]
            : fee.balance)
        ) {
          feeDues[index].payment = refundTotalDetails[fee.fee_due_id]
            ? fee.balance + refundTotalDetails[fee.fee_due_id]
            : fee.balance;
          remainingAmount -= refundTotalDetails[fee.fee_due_id]
            ? fee.balance + refundTotalDetails[fee.fee_due_id]
            : fee.balance;
        } else {
          feeDues[index].payment = remainingAmount;
          remainingAmount = 0;
        }
      } else {
        feeDues[index].payment = 0;
      }
    });
    await dispatch({
      type: UPDATE_STUDENT_DATA,
      payload: { feeDues },
    });
    return remainingAmount
      ? "Payment Amount is greater than existing Dues"
      : "";
  };

export const changePaymentAmountForFee =
  (feeID, amount) => async (dispatch, getState) => {
    const { feeBundleDetails } = getState().student;

    let unSortedFeeDues = [
      ...feeBundleDetails.filter((due) => Number(due.id) !== Number(feeID)),
      {
        ...feeBundleDetails.find((due) => Number(due.id) === Number(feeID)),
        payment: amount || 0,
      },
    ];
    unSortedFeeDues = [
      ...unSortedFeeDues.sort((a, b) => {
        if (a.priority < b.priority) return 1;
        if (a.priority > b.priority) return -1;
        if (a.id < b.id) return 1;
        if (a.id > b.id) return -1;
      }),
    ];
    await dispatch({
      type: UPDATE_STUDENT_DATA,
      payload: {
        feeBundleDetails: unSortedFeeDues,
      },
    });
  };

export const performSplitUp =
  (amount, refundTotalDetails) => async (dispatch, getState) => {
    let { feeDues } = getState().student;
    let remainingAmount = amount;
    feeDues.forEach((fee, index) => {
      if (remainingAmount) {
        if (
          remainingAmount >
          (refundTotalDetails[fee.fee_due_id]
            ? fee.balance + refundTotalDetails[fee.fee_due_id]
            : fee.balance)
        ) {
          feeDues[index].payment = refundTotalDetails[fee.fee_due_id]
            ? fee.balance + refundTotalDetails[fee.fee_due_id]
            : fee.balance;
          remainingAmount -= refundTotalDetails[fee.fee_due_id]
            ? fee.balance + refundTotalDetails[fee.fee_due_id]
            : fee.balance;
        } else {
          feeDues[index].payment = remainingAmount;
          remainingAmount = 0;
        }
      } else {
        feeDues[index].payment = 0;
      }
    });
    await dispatch({
      type: UPDATE_STUDENT_DATA,
      payload: { feeDues },
    });
    return remainingAmount
      ? "Payment Amount is greater than existing Dues"
      : "";
  };

export const performSplitUpForFee = (amount) => async (dispatch, getState) => {
  let { feeBundleDetails } = getState().student;
  let remainingAmount = amount;
  feeBundleDetails.forEach((fee, index) => {
    if (remainingAmount) {
      if (remainingAmount > fee.total_amount) {
        feeBundleDetails[index].payment = fee.total_amount;
        remainingAmount -= fee.total_amount;
      } else {
        feeBundleDetails[index].payment = remainingAmount;
        remainingAmount = 0;
      }
    } else {
      feeBundleDetails[index].payment = 0;
    }
  });
  await dispatch({
    type: UPDATE_STUDENT_DATA,
    payload: { feeBundleDetails },
  });
  return remainingAmount ? "Payment Amount is greater than existing Dues" : "";
};

export const performSplitUpForRefund =
  (amount, refundTotalDetails) => async (dispatch, getState) => {
    let { feePaid } = getState().student;
    let remainingAmount = amount;
    feePaid.forEach((fee, index) => {
      if (remainingAmount) {
        if (
          remainingAmount >
          (refundTotalDetails[fee.payment_id]
            ? fee.amount - refundTotalDetails[fee.payment_id]
            : fee.amount)
        ) {
          feePaid[index].payment = refundTotalDetails[fee.payment_id]
            ? fee.amount - refundTotalDetails[fee.payment_id]
            : fee.amount;
          remainingAmount -= refundTotalDetails[fee.payment_id]
            ? fee.amount - refundTotalDetails[fee.payment_id]
            : fee.amount;
        } else {
          feePaid[index].payment = remainingAmount;
          remainingAmount = 0;
        }
      } else {
        feePaid[index].payment = 0;
      }
    });
    await dispatch({
      type: UPDATE_STUDENT_DATA,
      payload: { feePaid },
    });
    return remainingAmount
      ? "Payment Amount is greater than existing Dues"
      : "";
  };

export const captureFeePayment =
  (paymentDate) => async (dispatch, getState) => {
    const { feeDues, id } = getState().student;
    const feePaymentData = feeDues.filter((fee) => fee.payment);
    const response = await Api({
      method: "post",
      url: "/fees/capture_fee_payment",
      data: {
        student_id: id,
        payment_date: paymentDate,
        fee_payment_data: JSON.stringify(feePaymentData),
      },
    });
    if (response.success) {
      await dispatch({
        type: UPDATE_STUDENT_DATA,
        payload: {
          feePaid: response.fee_paid,
          transactionId: response.transaction_id,
          unallocatedAmount: response.unallocated_amount,
        },
      });
    } else if (!!response.message) {
      await dispatch(showToast(response.message));
    } else {
      await dispatch(serverError());
    }
    return response;
  };

export const captureRefund = (refundData) => async (dispatch, getState) => {
  const { id } = getState().student;
  const response = await Api({
    method: "post",
    url: "/fees/capture_refund",
    data: {
      student_id: id,
      refund_data: JSON.stringify(refundData),
    },
  });
  if (response.success) {
    await dispatch({
      type: UPDATE_STUDENT_DATA,
      payload: { refundDetails: response.refund_details },
    });
  } else if (!!response.message) {
    await dispatch(showToast(response.message));
  } else {
    await dispatch(serverError());
  }
  return response;
};

export const updatePaymentModeNumber =
  (feeDueID, paymentModeNumber, key) => async (dispatch, getState) => {
    const { feeDues } = getState().student;

    let unSortedFeeDues = [
      ...feeDues.filter((due) => Number(due.fee_due_id) !== Number(feeDueID)),
      {
        ...feeDues.find((due) => Number(due.fee_due_id) === Number(feeDueID)),
        [key]: paymentModeNumber || "",
      },
    ];
    unSortedFeeDues = [
      ...unSortedFeeDues.sort((a, b) => {
        if (a.priority < b.priority) return 1;
        if (a.priority > b.priority) return -1;
        if (a.fee_due_id < b.fee_due_id) return 1;
        if (a.fee_due_id > b.fee_due_id) return -1;
      }),
    ];
    await dispatch({
      type: UPDATE_STUDENT_DATA,
      payload: {
        feeDues: unSortedFeeDues,
      },
    });
  };

export const updateRefundNumber =
  (feePaymentId, refundNumber, key) => async (dispatch, getState) => {
    const { feePaid } = getState().student;

    let unSortedPayments = [
      ...feePaid.filter(
        (payment) => Number(payment.payment_id) !== Number(feePaymentId)
      ),
      {
        ...feePaid.find(
          (payment) => Number(payment.payment_id) === Number(feePaymentId)
        ),
        [key]: refundNumber || "",
      },
    ];
    await dispatch({
      type: UPDATE_STUDENT_DATA,
      payload: {
        feeDues: _.sortBy(unSortedPayments, ["priority"], ["asc"]),
      },
    });
  };

export const getChangesToPaymentsTable = () => async (dispatch) => {
  await await dispatch({
    type: UPDATE_HOME_REDUCER,
    payload: { isLoading: true },
  });
  const response = await Api({
    method: "get",
    url: "/payments/get_payments_changes",
  });
  if (response.success) {
    await dispatch({
      type: UPDATE_HOME_REDUCER,
      payload: { paymentChanges: response.payment_changes },
    });
  }
  await dispatch({
    type: UPDATE_HOME_REDUCER,
    payload: { isLoading: false },
  });
  if (!!response.message) {
    await dispatch(showToast(response.message));
  }
  return response;
};
